module.exports = __webpack_public_path__ + "static/img/huanyingci.91755ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/huanyingci.png
// module id = fRsJ
// module chunks = 4